// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainRestorePassword {
    position: relative;
    max-width: 1280px;
    height: calc(100% - 33px);
    margin: 33px auto 0 auto;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.contentRestore {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.arrowReturn {
    align-self: flex-start;
    height: 25px;
    cursor: pointer;
}

.imgLogoRestore {
    width: 55%;
    margin-bottom: 30px;
}

.formRestore {
    width: 100%;
    background-color: #FFF4D9;
    border-radius: 16px;
    padding: 20px 34px 28px 34px;
    display: flex;
    flex-direction: column;
}

.formRestore h2 {
    color: #4B2D10;
    text-align: start;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 8px;
}

.formRestore p {
    color: #BB8D6C;
    font-size: 14px;
    margin-bottom: 40px;
}

.inputFormRestore {
    position: relative;
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    font-family: Alegreya Sans;
    color: #4B2D10;
    font-size: 20px;
    appearance: none;
    border-bottom: 1px #B48100 solid;
}

.inputMailRestore {
    margin-bottom: 70px;
}

.inputFormRestore::placeholder {
    color: #4B2D10;
}

.fieldsPasswordRestore {
    display: flex;
    flex-direction: column;
    gap: 33px;
    margin-bottom: 58px;
}

.contInputFieldRestore {
    position: relative;
}

.buttonRestore {
    width: 100%;
    height: 44px;
    background: #FFB800;
    padding: 10px 20px;
    margin: 0 auto;
    border-radius: 8px;
    border: none;
    font-size: 20px;
    color: #4B2D10;
    font-weight: 500;
    font-family: Alegreya Sans;
    cursor: pointer;
}

.imgPeopleRestore {
    width: 87%;
}

@media (min-width: 768px) {
    .imgLogoRestore {
        width: 40%;
        margin-bottom: 50px;
    }

    .formRestore {
        width: 90%;
        padding: 28px 34px 34px 34px;
    }

    .formRestore h2 {
        font-size: 36px;
    }

    .formRestore p {
        font-size: 18px;
    }

    .inputFormRestore {
        font-size: 24px;
    }

    .buttonRestore {
        width: max-content;
        height: 50px;
        font-size: 24px;
        padding: 10px 36px;
    }

    .imgPeopleRestore {
        width: 65%;
    }
}

@media (min-width: 1024px) {
    .imgLogoRestore {
        width: 400px;
        margin-bottom: 70px;
    }

    .formRestore {
        width: 70%;
    }

    .imgPeopleRestore {
        width: 50%;
    }
}

@media (min-width: 1152px) {
    .formRestore {
        width: 50%;
    }
}

@media (min-width: 1280px) {
    .imgPeopleRestore {
        width: 40%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login/RestorePassword/RestorePassword.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".mainRestorePassword {\n    position: relative;\n    max-width: 1280px;\n    height: calc(100% - 33px);\n    margin: 33px auto 0 auto;\n    padding: 0 16px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.contentRestore {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.arrowReturn {\n    align-self: flex-start;\n    height: 25px;\n    cursor: pointer;\n}\n\n.imgLogoRestore {\n    width: 55%;\n    margin-bottom: 30px;\n}\n\n.formRestore {\n    width: 100%;\n    background-color: #FFF4D9;\n    border-radius: 16px;\n    padding: 20px 34px 28px 34px;\n    display: flex;\n    flex-direction: column;\n}\n\n.formRestore h2 {\n    color: #4B2D10;\n    text-align: start;\n    font-size: 32px;\n    font-weight: 500;\n    margin-bottom: 8px;\n}\n\n.formRestore p {\n    color: #BB8D6C;\n    font-size: 14px;\n    margin-bottom: 40px;\n}\n\n.inputFormRestore {\n    position: relative;\n    width: 100%;\n    border: none;\n    outline: none;\n    background-color: transparent;\n    font-family: Alegreya Sans;\n    color: #4B2D10;\n    font-size: 20px;\n    appearance: none;\n    border-bottom: 1px #B48100 solid;\n}\n\n.inputMailRestore {\n    margin-bottom: 70px;\n}\n\n.inputFormRestore::placeholder {\n    color: #4B2D10;\n}\n\n.fieldsPasswordRestore {\n    display: flex;\n    flex-direction: column;\n    gap: 33px;\n    margin-bottom: 58px;\n}\n\n.contInputFieldRestore {\n    position: relative;\n}\n\n.buttonRestore {\n    width: 100%;\n    height: 44px;\n    background: #FFB800;\n    padding: 10px 20px;\n    margin: 0 auto;\n    border-radius: 8px;\n    border: none;\n    font-size: 20px;\n    color: #4B2D10;\n    font-weight: 500;\n    font-family: Alegreya Sans;\n    cursor: pointer;\n}\n\n.imgPeopleRestore {\n    width: 87%;\n}\n\n@media (min-width: 768px) {\n    .imgLogoRestore {\n        width: 40%;\n        margin-bottom: 50px;\n    }\n\n    .formRestore {\n        width: 90%;\n        padding: 28px 34px 34px 34px;\n    }\n\n    .formRestore h2 {\n        font-size: 36px;\n    }\n\n    .formRestore p {\n        font-size: 18px;\n    }\n\n    .inputFormRestore {\n        font-size: 24px;\n    }\n\n    .buttonRestore {\n        width: max-content;\n        height: 50px;\n        font-size: 24px;\n        padding: 10px 36px;\n    }\n\n    .imgPeopleRestore {\n        width: 65%;\n    }\n}\n\n@media (min-width: 1024px) {\n    .imgLogoRestore {\n        width: 400px;\n        margin-bottom: 70px;\n    }\n\n    .formRestore {\n        width: 70%;\n    }\n\n    .imgPeopleRestore {\n        width: 50%;\n    }\n}\n\n@media (min-width: 1152px) {\n    .formRestore {\n        width: 50%;\n    }\n}\n\n@media (min-width: 1280px) {\n    .imgPeopleRestore {\n        width: 40%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
